<template>
<div class="page_">
    <div class="form_con form_con1">
        <a-form layout="inline" @submit="handleChangePwdSubmit" :form="pwdForm">
            <a-form-item label="原始密码" >
                <a-input placeholder="请输入原始密码"  v-decorator="[
                'oldPassword',
                {
                  rules: [{ required: true, message: '请输入原始密码!' }]
                }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="新密码">
                <a-input placeholder="请输入新密码" v-decorator="[
                'newPassword',
                {
                  rules: [{ required: true, message: '请输入新密码!' }]
                }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="确认密码">
                <a-input placeholder="请确认新密码" v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请再次输入新密码!' }]
                }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="手机号">
                <a-input v-model="this.phone" readonly></a-input>
            </a-form-item>
            <a-form-item label="验证码">
              <a-input
                v-decorator="[
                  'code',
                  {
                    rules: [{ required: true, message: '请输入验证码' }],
                  },
                ]"
                placeholder="请输入手机验证码"
                size="large"
              >
              </a-input>
              <span @click="handleSendCode" class="btn_send_code_">{{count > 0 ? count + 's' :'发送验证码'}}</span>
          </a-form-item>
            <a-form-item style="width:167px;height:42px;line-height:42px;margin:37px auto 0;display:block;">
                <a-button type="primary"style="width:167px;height:42px;line-height:42px;" html-type="submit">确定</a-button>
            </a-form-item>
        </a-form>
    </div>
</div>
</template>
<style lang="scss" scoped>
  .form_con{
    width:320px;
    margin:0 auto;
    .ant-form-item{
      display:block;
       margin-bottom:15px;
      .ant-input{
        width:216px;
        height:34px;
        line-height:34px;
      }
      .ant-form-item-label{
        width:85px;
        text-align:right;
      }
    }
    .btn_send_code_{
      position:absolute;
      top:-11px;
      right:10px;
      cursor:pointer;
    }
  }
</style>
<script>
import navbar from '../components/navbar'
import api from '@/utils/api'
import { setLogined, setToken } from "@/utils/authorized";
export default {
    data () {
        document.title = '修改密码'
        return {
          pwdForm: this.$form.createForm(this),
          count: 0,
          submitDisabled: false,
          phone:'',
          phoneOrigin:''
        }
    },
    components: {
        navbar
    },
    mounted(){
      this.fetchData()
    },
    methods: {
        fetchData(){
          api.getCustomerWebUser().then(res => res.data).then(data => {
            if(data.returnCode==='0000'){
                  this.phone=data.data.loginName
                  this.phoneOrigin=data.data.loginName
                  if(this.phone!=''&&this.phone!=null&&this.phone!=undefined){
                    this.phone=this.phone.substring(0,3)+'****'+this.phone.substring(7,11)
                  }else{
                    this.phone='暂未绑定手机号'
                  }  
              }
          })
        },
        handleSendCode () {
          if(this.phone!=''&&this.phone!=null&&this.phone!=undefined){
              api.sendMessage({}).then(res => res.data).then(data => {
                if(data.returnCode==='0000'){
                  this.startCountDown()
                }else{
                   this.$notification.open({
                      message: '发送验证码提醒',
                      description:data.returnMsg,
                      duration: 2,
                  });
                }
                
              })  
          }else{
            this.$notification.open({
                message: '修改密码提醒',
                description:'您的账号暂未绑定手机号，请先在手机端绑定手机号再修改密码',
                duration: 2,
            });
          }
        },
        startCountDown () {
          if (this.count > 0) {
            return
          }
          this.count = 59
          let st = setInterval(() => {
            this.count--
            if (this.count < 1) {
              clearInterval(st)
            }
          }, 1000);
        },
        handleChangePwdSubmit(e) {
            e && e.preventDefault();
            this.submitDisabled = true;
            let st = setTimeout(() => {
              clearTimeout(st);
              this.submitDisabled = false;
            }, 60 * 1000);
            this.pwdForm.validateFields((error, values) => {
               console.log("handleChangePwdSubmit -> ", values)
                if (!error) {
                  if(values.newPassword!=values.password){
                     this.$notification.open({
                          message: '输入提醒',
                          description:'两次密码不一致，请重新输入',
                          duration: 2,
                      });
                  }else if(this.phoneOrigin===''||this.phoneOrigin===null||this.phoneOrigin===undefined){
                    this.$notification.open({
                          message: '修改密码提醒',
                          description:'您的账号暂未绑定手机号，请先在手机端绑定手机号再修改密码',
                          duration: 2,
                      });
                  }else{
                    let requestData={...values}
                    requestData.phone=this.phoneOrigin
                    console.log(requestData,'requestData')
                    api.changePassword(requestData).then(res => res.data).then(data => {
                      if(data.returnCode==='0000'){
                        this.pwdForm.resetFields()
                        setToken('')
                        var num = Math.ceil(Math.random() * 10);
                        window.router.push({ name: "login", params: { num } });
                      }else{
                        this.$notification.open({
                            message: '修改密码提醒',
                            description:data.returnMsg,
                            duration: 2,
                        });
                      }
                    })
                  }
                }
            });
        },
    }
}
</script>